import React from "react";
import { Component } from "react";
import JobOfferPopup from "./JobOfferPopup";
import JobRejectPopup from "./JobRejectPopup";
import offerimage from "views/profile/img/offersimage.png";
import offerletter from "views/profile/img/offerletter.png";
class JobsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowDetails: true,
      isoffermodalopen: false,
      jobOffers: "",
      isrejectrmodalopen: false,
      jobReject: "",
    };
  }

  render() {
    const { jobOffers, jobReject } = this.state;
    return (
      <card className="rounded-12px drop-shadow20 bg-white block lg:p-8 md:p-8 p-5 mt-4 sm-shadow-none">
        <JobOfferPopup
          showOffer={this.state.isoffermodalopen}
          jobOffers={jobOffers}
        />
        <JobRejectPopup
          showReject={this.state.isrejectmodalopen}
          jobReject={jobReject}
        />
        <div>
          <div className="text-center py-10 ">
            <div>
              <img
                src={offerimage}
                className="h-195px m-auto sm-height136px  sm-full"
              />
            </div>
            <p className="fsize20 line-h30 sm-fsize14 lg:w-1/2 md:w-1/2 w-full m-auto pt-12  lg:px-0 md:px-0 px-6">
              You have digitally accepted the offer letter on July 21, 2021 You
              and your joining date is{" "}
              <span className="font-bold">August 10, 2021</span>
            </p>
            <div className="lg:mt-16 md:mt-16 mt-12">
              <div className="shadow-16blur sm-shadow-none sm-rounded-6px bgF7F7F7 h-150px flex justify-center items-center lg:w-3/4 md:w-3/4	w-full m-auto lg:p-20 md:p-20 p-6">
                <p className="fsize20 line-h30 sm-fsize14">
                  <b>Note:</b> You can’t modify your joining date more than
                  once. If you wish to modify your joining date, please rate a
                  ticket.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center lg:py-10  md:py-10 py-4 hidden">
            <div>
              <img
                src={offerimage}
                className="h-195px m-auto sm-height136px  sm-full"
              />
            </div>
            <p className="fsize20 line-h30 lg:w-1/2 md:w-1/2 w-3/4 sm-fsize16 m-auto font-bold pt-12">
              Congratulations!
            </p>
            <p className="fsize20 line-h30 lg:w-1/2 sm-fsize14 md:w-1/2 w-3/4 m-auto  lg:pt-4 md:pt-4 pt-0">
              You have recieved the offer letter by ICICI Bank
            </p>
            <div className="mt-16">
              <div className="shadow-16blur bgF7F7F7 lg:flex md:flex justify-center items-center lg:w-3/4 md:w-3/4 w-full	 m-auto ">
                <div className="lg:w-1/2 md:w-1/2 w-full">
                  <div className="relative w-404px sm-w-full">
                    <img
                      src={offerletter}
                      alt="offerletter"
                      className="rounded-lg h-230px sm-h198px sm-w-full"
                    />
                    <p className="underline text-white fsize20 font-bold absolute top-0 h-full justify-center flex items-center w-full cursor-pointer ">
                      View Offer Letter
                    </p>
                  </div>
                </div>
                <div className="lg:w-1/2 md:w-1/2 w-full lg:p-0 md:p-0 p-6">
                  <p className="fsize18 sm-fsize14 line-h30 lg:pr-12 md:pr-12">
                    <b>Note:</b> The document is password protected, To view,
                    enter your date of birth in DDD/MM/YYYY format.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-20 sm-flex-center sm-fixed-bottom-offer">
              <button
                className="outline-button uppercase rounded-25px sm-w-50per sm-fsize14 fsize16 font-bold w-230px h-50px mr-3"
                onClick={() => this.setState({ isrejectmodalopen: true })}
              >
                REJECT
              </button>
              <button
                className="filled-button uppercase rounded-25px sm-w-50per sm-fsize14 fsize16 font-bold w-230px h-50px ml-3"
                onClick={() => this.setState({ isoffermodalopen: true })}
              >
                ACCEPT
              </button>
            </div>
          </div>

          <div className="text-center py-10 hidden">
            <div>
              <img
                src={offerimage}
                className="h-195px m-auto sm-height136px sm-w-full"
              />
            </div>
            <p className="fsize20 line-h30 lg:w-1/2 md:w-1/2 sm-fsize14 m-auto pt-12 lg:px-0 md:px-0 px-6">
              You have digitally accepted the offer letter on July 21, 2021 You
              and your joining date is{" "}
              <span className="font-bold">August 10, 2021</span>
            </p>
            <div className="lg:mt-16 md:mt-16 mt-12">
              <card className="shadow-16blur sm-rounded-6px offer-ch-150px lg:flex block  md:flex justify-center items-center lg:w-3/4 md:w-3/4 w-full	 m-auto lg:p-8 md:p-8 p-4">
                <div className="lg:w-1/2 md:w-1/2 w-full lg:pr-10 md:pr-10">
                  <p className="fsize18 line-h30 sm-fsize14 lg:px-0 md:px-0 px-6">
                    <b>Note:</b> If you wish to modify your joining date, please
                    enter a new date.
                  </p>
                </div>

                <div className="lg:w-1/2 md:w-1/2 w-full">
                  <div class="form-group  modal-form-cs text-left">
                    <label for="">Select Joining Date</label>
                    <input type="date" placeholder="" />
                  </div>
                </div>
              </card>
            </div>
            <div className="lg:mt-12 md:mt-12 mt-8 sm-w-full ">
              <button className="filled-button uppercase rounded-25px  sm-fsize14 fsize16 font-bold submit-offer-btn h-50px ml-3">
                SUBMIT
              </button>
            </div>
          </div>
        </div>
      </card>
    );
  }
}
export default JobsList;
